export default __webpack_public_path__ + "static/gs-5-businessvalue-9bcc5431e094a23a8ba5fb73a4094973.webp";